class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.interval = null;
      this.endTime = null;
    }
  
    connectedCallback() {
      // Parse the date and time from the element's attributes
      const date = this.getAttribute('data-date').split('-').reverse().join('-');
      const time = this.getAttribute('data-time');
      
      // Construct the date string and create a Date object
      this.endTime = new Date(`${date}T${time}:00`);
  
      if (isNaN(this.endTime.getTime())) {
        console.error('Invalid date format');
        return;
      }
  
      // Begin the countdown
      this.startCountdown();
    }
  
    startCountdown() {
      this.interval = setInterval(() => {
        const now = new Date();
        const difference = this.endTime - now;
  
        if (difference <= 0) {
          this.stopCountdown();
          this.render({ days: 0, hours: 0, minutes: 0, seconds: 0 });
          return;
        }
  
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((difference / 1000 / 60) % 60);
        const seconds = Math.floor((difference / 1000) % 60);
  
        this.render({ days, hours, minutes, seconds });
      }, 1000);
    }
  
    stopCountdown() {
      clearInterval(this.interval);
      this.interval = null;
    }
  
    render(time) {
      this.querySelector('.time-segment.days .time-number').innerText = time.days;
      this.querySelector('.time-segment.hours .time-number').innerText = time.hours;
      this.querySelector('.time-segment.minutes .time-number').innerText = time.minutes;
      this.querySelector('.time-segment.seconds .time-number').innerText = time.seconds;
    }
  
    disconnectedCallback() {
      this.stopCountdown();
    }
  }
  
  customElements.define('countdown-timer', CountdownTimer);
  